const React = require('react');
const isNode = (typeof process !== 'undefined');
const range = isNode ? require('lodash').range : {};
const Select = isNode ? require('react-select') : <div/>;
const Input = require('./../../FormComponents/Input');

class Faktura extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoiceMonth: null,
            invoiceYear: null,
            deliveryType: null
        };
        this.setInvoiceMonth = this.setInvoiceMonth.bind(this);
        this.setInvoiceYear = this.setInvoiceYear.bind(this);
        this.setDeliveryType = this.setDeliveryType.bind(this);
    }
    getValues() {
        return {
            address: this.address.value,
            invoiceMonth: this.state.invoiceMonth.label,
            invoiceYear: this.state.invoiceYear.label,
            deliveryType: this.state.deliveryType.label,
            comment: this.comment.value,
        }
    }
    setDeliveryType(option) {
        this.setState({deliveryType: option});
    }
    setInvoiceMonth(option) {
        this.setState({invoiceMonth: option});
    }
    setInvoiceYear(option) {
        this.setState({invoiceYear: option});
    }
    render() {
        const {hideHeaders, color} = this.props;

        const deliveryType = this.state.deliveryType && this.state.deliveryType.value;
        const deliveryTypeOptions = [
            { value: 'epost', label: 'E-post' },
            { value: 'post', label: 'Post' },
        ];

        const invoiceMonth = this.state.invoiceMonth && this.state.invoiceMonth.value;
        const invoiceMonthOptions = [
            {value: 'januar', label: 'Januar'},
            {value: 'februar', label: 'Februar'},
            {value: 'mars', label: 'Mars'},
            {value: 'april', label: 'April'},
            {value: 'mai', label: 'Mai'},
            {value: 'juni', label: 'Juni'},
            {value: 'juli', label: 'Juli'},
            {value: 'august', label: 'August'},
            {value: 'september', label: 'September'},
            {value: 'oktober', label: 'Oktober'},
            {value: 'november', label: 'November'},
            {value: 'desember', label: 'Desember'},
        ];

        const invoiceYear = this.state.invoiceYear && this.state.invoiceYear.value;
        const currentYear = new Date().getFullYear() + 1;
        const startYear = 2000;

        const invoiceYearOptions = range(startYear, currentYear).map(year => {
            return { value: year, label: year }
        });

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Kopi av faktura</h2>}
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="address" type="text" placeholder="Adresse" ref={(address) => this.address = address}/>
            </div>
            <div className="forms__formElement">
                <Select value={invoiceMonth} onChange={this.setInvoiceMonth} name="invoiceMonth" options={invoiceMonthOptions} className="react-select-custom" placeholder="Velg måned"/>
                <Select value={invoiceYear} onChange={this.setInvoiceYear} name="invoiceYear" options={invoiceYearOptions} className="react-select-custom" placeholder="Velg år"/>
            </div>
            <div className="forms__formElement">
                <Select value={deliveryType} onChange={this.setDeliveryType} name="deliveryType" options={deliveryTypeOptions} className="react-select-custom" placeholder="Jeg ønsker faktura tilsendt på"/>
            </div>
            <div className="forms__formElement">
                <label className="form-label">Andre kommentarer</label>
                <textarea placeholder="Andre kommentarer" ref={(comment) => this.comment = comment}/>
            </div>
        </div>
        )
    }
}

module.exports = Faktura;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/Faktura/index.jsx